// import { eventBus } from '@/main.js'
export default {
  methods: {
    modalOnMobileLandscape () {
      if (this.isMobile) {
        this.showModal = this.isLandscape()
      }
    },
    isLandscape: function () {
      if (!this.fullScreenActive) {
        this.window.width = window.innerWidth
        this.window.height = window.innerHeight
        return this.getOrientation()
      } else {
        return false
      }
    },
    getOrientation () {
      if (this.isMobile) {
        // let iOS = !!navigator.platform && /iPhone|iPod/.test(navigator.platform)
        if (this.isIphone()) {
          if (typeof window.orientation === 'number') {
            // ... and if the absolute value of orientation is 90...
            return Math.abs(window.orientation) === 90
          }
        } else {
          if (typeof window.screen.orientation.type === 'string') {
            // ... and if the absolute value of orientation is 90...
            return (window.screen.orientation.type === 'landscape-primary' || window.screen.orientation.type === 'landscape-secondary')
          }
        }
      } else {
        return false // window.orientation not available
      }
    }
  }
}
